const handleDeleteClicked = ({ e, deleteGroupMutation }) => {
  const id = e?.gridParam?.data?.id;
  deleteGroupMutation({ id });
};

export default handleDeleteClicked;
